import { IGetState, TBoardId, TCardId } from '../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IComment } from '../../../../store/model/card/types/IComment';
import { getCard } from '../../../../store/model/selectors/getCard';
import { ICards } from '../../../../store/model/cards/types';
import { getCardsForRollback } from '../../../../store/model/selectors/getCardsForRollback';
import { cardsUpdate } from '../../../../store/model/actionCreators/cardsUpdate';
import { cardTotalSpentTimeUpdate } from '../card/cardTotalSpentTimeUpdate';
import { patchRest } from './api/patchRest';
import { cardsActiveRequestsUpdate } from '../../../../store/requestsState/effects/cardsActiveRequestsUpdate';
import { sendRealTimeStoreActionByBoardId } from '../../../../view/react_components/base/helpers/realTimeHelperTS';
import { getCommentById } from '../../../../view/react_components/base/components/Comments/selectors/getCommentById';

export const commentUpdate = (
    comment: Partial<IComment>,// todo O_O create ICommentPatch to strict cardId, and commentId
    boardId: TBoardId,
    isRealtime: boolean = true, // send event to socket
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const cardId: TCardId = comment.cardId;
        const state = getState();
        const card = getCard(state, cardId);
        const oldComment = getCommentById(state,cardId, comment.id)
        const comments = card.comments.map((com) => {
            return com.id === comment.id ? {...com, ...comment} : com;
        });
        const cards: ICards = {
            [cardId]: {
                comments
            }
        };

        let cardsForRollback = getCardsForRollback(state, cards);
        dispatch(cardsUpdate(cards));
        dispatch(cardsActiveRequestsUpdate(cards, 1));

        return dispatch(patchRest(comment))
            .then((comment: IComment) => {
                if (isRealtime) {
                    dispatch(sendRealTimeStoreActionByBoardId(boardId, cardsUpdate(cards)));
                }
                if (oldComment.timeTracker || comment.timeTracker){
                    dispatch(cardTotalSpentTimeUpdate(boardId, cardId))
                }
                return comment;
            })
            .catch((e: any) => {
                console.error(e);
                dispatch(cardsUpdate(cardsForRollback));
            })
            .finally(() => {
                dispatch(cardsActiveRequestsUpdate(cards, -1));
            });
    };
    return action;
};
